
const LoginLeftContent = () => {
    return <div class="left w-1/3 content-center">
        <p className="mb-4 text-xl font-normal">Upload your property in 4 simple steps</p>
        <div className="flex items-center text-sm"><img src="./greenTick.png" alt="1" />
            <p>Add your properties <span className="font-extrabold">Basic Details</span></p>
        </div>
        <div className="flex items-center text-sm"><img src="./greenTick.png" alt="2" />
            <p>Add property <span className="font-extrabold">Location</span></p>
        </div>
        <div className="flex items-center text-sm"><img src="./greenTick.png" alt="3" />
            <p>Add property <span className="font-extrabold">Features and amenities</span></p>
        </div>
        <div className="flex items-center text-sm"><img src="./greenTick.png" alt="4" />
            <p>Add <span className="font-extrabold">Price details</span></p>
        </div>
        <div className="flex items-center text-sm"><img src="./greenTick.png" alt="5" />
            <p>Add your best <span className="font-extrabold">Property Shots</span></p>
        </div>
    </div>
}

export default LoginLeftContent;